export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (cname) => {
  const name = `${cname}=`;
  return document.cookie.split(';')
    .map(c => c.trimStart()) // remove spaces at the start
    .filter(c => c.startsWith(name)) // filter items starts with `name`
    .map(c => c.substring(name.length)) // remove `name` from items
    .shift(); // take first item (it returns undefined if nothing pass here)
};
